var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-card"},[_c('loading-default',{attrs:{"loadingVisible":_vm.loadingVisible,"headline":_vm.loadingHeadline,"excerpt":_vm.loadingExcerpt,"showRestoreCart":true,"abort":_vm.abort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }